<script setup>
import { useNuxtApp } from "#app";
const backendStore = useBackendStore();
const { isEmbed } = backendStore;
const carCount = backendStore.carCount.value;

useHead({
  title: "Vehis.pl - atrakcyjny leasing samochodów nowych i używanych",
  meta: [
    {name: 'description', content: 'Leasing samochodów z atrakcyjnymi warunkami finansowania  u lidera w branży ✔️ Decyzja w 15 min. Sprawdź!'}
  ],
  link: [{ rel: "canonical", href: "https://vehis.pl" }],
  script: [
    {
      type: "application/ld+json",
      children: JSON.stringify(useOrganizationStructuredData()),
    },
  ],
});

const { $onEvent } = useNuxtApp();
const showContactPopup = ref(false);
const contactPopupTitle = ref("Zostaw kontakt!");
const isCalculatorVisible = ref(false);
const showInitiallyCalculator = ref(false);

const { data: cars } = useAsyncData("cars", () =>
  useBackend().getModels({ promoted: 1 })
);

const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

const { data: popularCars } = useAsyncData("popularCars", async () => {
  const models = await useBackend().getPopularModels();
  return shuffleArray(models.data);
});

const { data: embedConfig } = await useAsyncData("embed-config", async () => {
  if (isEmbed) {
    const res = await useBackend().getEmbedConfig();
    if (res.status === 200 && res?.data?.lead_form) {
      return res.data;
    }
  }
  return {};
});

const isEmbedHasLead = computed(() => !!embedConfig.value?.lead_form);

const isEmbedHasCalculator = computed(() => {
  return isEmbed && !!embedConfig.value?.calculator;
});

const isEmbedHasAllBrands = computed(() => !!embedConfig.value?.all_brands);

$onEvent("specialBanner:click", () => {
  showContactPopup.value = true;
});

$onEvent("specialBanner:click", () => {
  showContactPopup.value = true;
});

onMounted(() => {
  const isMobile = window.innerWidth < 688;
  showInitiallyCalculator.value = !isMobile;
  isCalculatorVisible.value = false
});
</script>

<template>
  <Container no-paddings>
    <div class="relative" ref="appTopRef">
      <AppTop :all-brands="isEmbedHasAllBrands" />
    </div>
  </Container>

  <NewCalculatorContainer
    class=" z-30"
    v-if="isEmbedHasCalculator || !isEmbed"
    :isVisible="isCalculatorVisible"
    @toggle="isCalculatorVisible = !isCalculatorVisible"
  />

  <Container no-paddings>
    <div>
      <LayoutColumns>
        <LayoutMainCarsColumn
          :full="isEmbed && !isEmbedHasLead"
          class="pb-4"
          v-show="popularCars.length > 0"
          :isEmbed="isEmbed && !isEmbedHasLead"
        >
          <div
            :class="
              !isEmbed || (isEmbed && isEmbedHasLead)
                ? 'md:col-span-2 lg:col-span-2 xl:col-span-3 -mb-6'
                : 'col-span-2 md:col-span-2 lg:col-span-3 xl:col-span-4'
            "
          >
            <MainContentHeader
              >Leasing samochodu w VEHIS - najpopularniejsze
              modele</MainContentHeader
            >
          </div>
          <template v-for="(car, index) in popularCars.slice(0, 6)">
            <CarTile :car="car" :bg="{ img: car.background_image }" :is-popular-car="true"/>
          </template>
        </LayoutMainCarsColumn>
        <LayoutSideColumn
          class="lg:mt-20 pb-4 !bg-transparent"
          v-if="!isEmbed || (isEmbed && isEmbedHasLead)"
        >
          <FormContact />
          <div class="h-4"></div>
        </LayoutSideColumn>
      </LayoutColumns>
    </div>
  </Container>

  <LazyCarDayOffers v-if="!isEmbed" />

  <LazyCarVideoReel v-if="!isEmbed" />
   <!-- <LazyCarFullVideoPromo v-if="!isEmbed" gray/> -->

  <LazyBannerBenefits v-if="!isEmbed" />

  <LazyCarCollections v-if="!isEmbed" />

  <Container v-if="!isEmbed">
    <LazySeoMoreAboutModels :cars="cars.data" title="Oferta tygodnia:" />
  </Container>

  <Container with-border-top v-if="!isEmbed">
    <LazyBlockBestFeaturesCompared />
  </Container>

  <Container class="pt-8 pb-4" no-paddings with-border-top v-if="!isEmbed">
    <LazyBlockHowTo
      :steps="[
        `Wybierz samochód z ponad <b>${carCount}</b> dostępnych ofert.`,
        '<b>Wspólnie skalkulujemy</b> ofertę<br/>finansowania i ubezpieczenia.',
        'Finansowanie przyznamy<br/><b>w 15 minut</b> od złożenia wniosku.',
        'Samochód odbierzesz nawet<br/><b>w 24h</b> od podpisania umowy.',
      ]"
    />
  </Container>

  <Container class="pt-8 pb-12" no-paddings with-border-top v-if="!isEmbed">
    <LazySeoHomePage />
  </Container>

  <Container class="pt-10 pb-6" no-paddings gray v-if="!isEmbed">
    <LazyBlockFeaturesComparedText />
  </Container>

  <Container v-if="!isEmbed">
    <LazyFormContact
      title="W każdym momencie możesz skorzystać z&nbsp;pomocy naszych Doradców"
      standalone
    />
  </Container>

  <LazySeoLinks v-if="!isEmbed" />

  <Teleport to="body">
    <PopupModal
      :openPopup="showContactPopup"
      @update:openPopup="showContactPopup = false"
    >
      <FormContact
        :title="contactPopupTitle"
        standalone
        no-container
        analytics-form-type="home-baner-popup"
      />
    </PopupModal>
  </Teleport>
</template>
